import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function TermsOfService() {
    return (
        <LegalPage title="Terms of Service" lastUpdated="May 26, 2026">
            <p>
                Welcome to{" "}
                <a
                    href="https://www.caribbeanmealprep.net"
                    className="text-forest font-bold underline"
                >
                    Caribbean Meal Prep
                </a>
                . By accessing or using our website, services, or placing an
                order, you agree to the following Terms of Service
                (&ldquo;Terms&rdquo;).
            </p>
            <p>
                Please read these Terms carefully before using our website or
                purchasing from us.
            </p>

            <h2>1. Overview</h2>
            <p>
                This website is operated by Caribbean Meal Prep. Throughout the
                site, the terms &ldquo;we,&rdquo; &ldquo;us,&rdquo; and
                &ldquo;our&rdquo; refer to Caribbean Meal Prep.
            </p>
            <p>
                By visiting our website or purchasing our products or services,
                you agree to be bound by these Terms of Service, including any
                policies referenced within them.
            </p>
            <p>
                If you do not agree to these Terms, please do not use our
                website or services.
            </p>

            <h2>2. Online Store Terms</h2>
            <p>By using this site, you confirm that:</p>
            <ul>
                <li>You are at least the age of majority in your state or province.</li>
                <li>You will not use our products or services for any unlawful purpose.</li>
                <li>You will not attempt to interfere with the security or operation of the website.</li>
            </ul>
            <p>
                Any violation of these Terms may result in suspension or
                termination of access to our services.
            </p>

            <h2>3. Products &amp; Services</h2>
            <p>
                Caribbean Meal Prep provides healthy Caribbean-style meal
                preparation and related food services.
            </p>
            <p>We focus on:</p>
            <ul>
                <li>Healthy meal prep</li>
                <li>Baked and grilled meals</li>
                <li>Weekly meal packages</li>
                <li>Online ordering</li>
            </ul>
            <p>
                All products are subject to availability. We reserve the right
                to:
            </p>
            <ul>
                <li>Limit quantities</li>
                <li>Modify menu items</li>
                <li>Change pricing</li>
                <li>Discontinue products at any time</li>
            </ul>
            <p>
                Images on the website are for illustration purposes. Actual
                meals may vary slightly in appearance.
            </p>

            <h2>4. Pricing &amp; Payments</h2>
            <p>Prices are subject to change without notice.</p>
            <p>
                By placing an order, you agree to provide accurate payment and
                billing information. Payments are processed securely through
                trusted third-party providers.
            </p>
            <p>
                We reserve the right to refuse or cancel orders at our
                discretion, including suspected fraudulent or abusive activity.
            </p>

            <h2>5. Meal Orders &amp; Delivery</h2>
            <p>Customers are responsible for:</p>
            <ul>
                <li>Providing accurate delivery information</li>
                <li>Being available during delivery windows when applicable</li>
                <li>Properly storing meals upon delivery or pickup</li>
            </ul>
            <p>
                Caribbean Meal Prep is not responsible for issues resulting
                from:
            </p>
            <ul>
                <li>Incorrect delivery information</li>
                <li>Delayed pickup by the customer</li>
                <li>Improper food storage after delivery</li>
            </ul>

            <h2>6. Refunds &amp; Cancellations</h2>
            <p>Due to the nature of prepared food products:</p>
            <ul>
                <li>All sales may be considered final once meal preparation has started.</li>
                <li>Refunds or credits may be issued at our discretion.</li>
                <li>Orders canceled before preparation may qualify for partial or full refunds.</li>
            </ul>
            <p>
                If there is an issue with your order, please contact us promptly
                through{" "}
                <a
                    href="https://www.caribbeanmealprep.net"
                    className="text-forest font-bold underline"
                >
                    www.caribbeanmealprep.net
                </a>
                .
            </p>

            <h2>7. Health &amp; Allergy Disclaimer</h2>
            <p>Our meals may contain or come into contact with:</p>
            <ul>
                <li>Dairy</li>
                <li>Eggs</li>
                <li>Nuts</li>
                <li>Seafood</li>
                <li>Wheat</li>
                <li>Soy</li>
                <li>Other allergens</li>
            </ul>
            <p>
                Customers with food allergies or dietary restrictions should
                contact us before ordering.
            </p>
            <p>
                Caribbean Meal Prep is not liable for allergic reactions or
                health-related issues resulting from consumption of our
                products.
            </p>

            <h2>8. Website Accuracy</h2>
            <p>
                We strive to provide accurate information on our website, but
                we do not guarantee that all information, pricing, descriptions,
                or availability will always be current, complete, or error-free.
            </p>
            <p>
                We reserve the right to correct errors or update information at
                any time without prior notice.
            </p>

            <h2>9. Third-Party Services</h2>
            <p>
                Our website may include links or integrations with third-party
                services such as payment processors, delivery platforms, or
                social media tools.
            </p>
            <p>
                We are not responsible for the content, policies, or practices
                of third-party services.
            </p>

            <h2>10. Intellectual Property</h2>
            <p>
                All content on this website, including logos, branding, text,
                graphics, and images, belongs to Caribbean Meal Prep and may
                not be copied, reproduced, or used without written permission.
            </p>

            <h2>11. Limitation of Liability</h2>
            <p>Caribbean Meal Prep shall not be held liable for:</p>
            <ul>
                <li>Indirect or incidental damages</li>
                <li>Delivery delays outside our control</li>
                <li>Website interruptions</li>
                <li>Food spoilage due to improper storage by the customer</li>
                <li>Allergic reactions or dietary sensitivities</li>
            </ul>
            <p>Use of our services is at your own risk.</p>

            <h2>12. Privacy</h2>
            <p>
                Your use of our website is also governed by our{" "}
                <a href="/privacy" className="text-forest font-bold underline">
                    Privacy Policy
                </a>
                .
            </p>

            <h2>13. Changes to Terms</h2>
            <p>
                We reserve the right to update or modify these Terms at any
                time. Changes will be posted on this page with an updated
                effective date.
            </p>
            <p>
                Continued use of the website after changes are posted
                constitutes acceptance of those changes.
            </p>

            <h2>14. Governing Law</h2>
            <p>
                These Terms shall be governed by and interpreted in accordance
                with the laws of the United States and the Commonwealth of
                Massachusetts.
            </p>

            <h2>15. Contact Information</h2>
            <p>
                Questions regarding these Terms of Service may be submitted
                through our website or email:
            </p>
            <ul>
                <li>
                    Website:{" "}
                    <a
                        href="https://www.caribbeanmealprep.net"
                        className="text-forest font-bold underline"
                    >
                        www.caribbeanmealprep.net
                    </a>
                </li>
                <li>
                    Email:{" "}
                    <a
                        href="mailto:caribbeanmealp@gmail.com"
                        className="text-forest font-bold underline"
                    >
                        caribbeanmealp@gmail.com
                    </a>
                </li>
            </ul>
        </LegalPage>
    );
}
